import React from 'react';
import { CTAModal } from 'Components/Modals/CTA/CTAModal';
import warning from 'common/assets/icons/success-failure-warn/warn/white-fill-circle-warning.svg';
import { observer } from 'mobx-react';
import { stores } from 'stores';
import { useTranslation } from 'react-i18next';

const { AppStore } = stores;

export const SessionExpiredModal = () => {
  const { t } = useTranslation();
  return (
    <CTAModal
      modalID="session-expired"
      icon={warning}
      headingColor="black"
      heading={t('modals.sessionExpired.heading', 'Your session has expired')}
      button={null}
      onClose={AppStore.logout}
    >
      {' '}
      {t('modals.sessionExpired.text', 'Please log in again to continue')}
    </CTAModal>
  );
};

export default observer(SessionExpiredModal);
